import { VIEW_TYPE } from 'src/app/core/constants/view-type.enum';
import { RouterPathConfig } from '../../core/constants/router-path.config';

export class PeriodicReviewConstants {
    public static REPORTS = {
        title: 'reports',
        path: RouterPathConfig.PERIODIC_REVIEW_PATH.REPORTS,
        viewType: VIEW_TYPE.REPORT,
        status: 0,
        count: undefined,
        name: 'REPORTS',
        icon: ''
    };

    public static SHARED_REPORTS = {
        title: 'shardReports',
        path: RouterPathConfig.PERIODIC_REVIEW_PATH.SHARED_REPORTS,
        viewType:VIEW_TYPE.SHARED_REPORTS,
        status: 0,
        count: undefined,
        name: 'SHARED_REPORTS',
        icon: ''
    };

    public static REPORT_FIELDS_MAX_LENGTH = {
        createReport: 2000,
       
    };
}